import clsx from 'clsx';
import React from 'react';
import { useLocale } from 'next-intl';
import { tabButton, tabIndicator, tabIndicatorLine, tabSwitch, TabSwitchVariantProps } from 'styled-system/recipes';

interface TabSwitchProps {
	tabs: React.ReactNode[];
	onTabChange: (selectedIndex: number) => void;
	selectedIndex: number;
	variant?: TabSwitchVariantProps;
	className?: string;
}

export const TabSwitch: React.FC<TabSwitchProps> = ({
	className,
	tabs,
	onTabChange,
	selectedIndex,
	variant,
}) => {
	const locale = useLocale();

	return (
		<div className={clsx(tabSwitch(variant), className)}>
			<div
				className={tabIndicator()}
				style={{
					[locale === 'ar-EG' ? 'right' : 'left']: `calc(${(100 / tabs.length) * selectedIndex}%)`,
					width: `${100 / tabs.length}%`,
				}}
			>
				<div className={tabIndicatorLine()}></div>
			</div>
			{tabs.map((tab, index) => (
				<div
					key={index}
					className={tabButton()}
					data-selected={selectedIndex === index}
					onClick={() => onTabChange(index)}
				>
					{tab}
				</div>
			))}
		</div>
	);
};